/**
 * The reference admin decides its "mobile" templates once, at page load:
 *   IS_MOBILE = getWidth() < 1280   (getWidth = documentElement.clientWidth, capped at innerWidth)
 * Casino pages (My Bets, sidebar wrapper) switch markup on it, so we mirror it exactly.
 */
function getWidth() {
  if (typeof window === "undefined") return 1280;
  const el = document.documentElement;
  let width = el.clientWidth;
  if (window.innerWidth && width > window.innerWidth) width = window.innerWidth;
  return width;
}

export const IS_REF_MOBILE = getWidth() < 1280;
